import { Component, Input, OnInit } from '@angular/core';
import { LoaderI } from 'src/app/core/interfaces/table.interface';

@Component({
  selector: 'app-shimmer',
  templateUrl: './shimmer.component.html',
  styleUrls: ['./shimmer.component.scss'],
})
export class ShimmerComponent implements OnInit {
  @Input() loaderType: LoaderI;
  @Input() shimmerSize: string;
  @Input() lineSize: 'sm' | 'lg' | 'md' | 'md-alt';
  // Used to loop through the shimmer for a number of times
  get cardCount(): Array<number> {
    return Array(this.loaderType.columns * 2);
  }
  constructor() {}

  ngOnInit(): void {}
}
